import moment from "moment";
import { TipDetails, TipFilter, TipStatus } from "model/Tip";

export const getFilteredTips = (
  tips: TipDetails[],
  selectedFilter: TipFilter
): TipDetails[] => {
  let filtered: TipDetails[];

  switch (selectedFilter) {
    case TipFilter.Saved:
      filtered = tips.filter((tip) => tip.status === TipStatus.Saved);
      break;
    case TipFilter.ReadyToPayout:
      filtered = tips.filter((tip) => tip.status === TipStatus.Done);
      break;
    case TipFilter.PaidOut:
      filtered = tips.filter(
        (tip) =>
          tip.status === TipStatus.Closed ||
          tip.status === TipStatus.ClosedManually
      );
      break;
    default:
      filtered = tips;
  }

  return filtered.sort((a, b) => moment(a.date).diff(moment(b.date)));
};
